/**
 * Formats a date string to "Month Day, Year" format (e.g., "January 10, 2024").
 * Mirrors the implementation in @highereducation/se-supersonic-ui.
 */
export const formatDate = (date?: string): string | null => {
  if (!date || !Date.parse(date)) {
    return null;
  }

  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
